import React, { Component } from 'react';

import "../css/Header.css";

class Header extends Component {
    render() {
        return (
            <div className="headerspace">
                <h1 className="fixed-top">MEGUMI HIRAMOTO</h1>
            </div>
        );
    }
}

export default Header;
